window.calendarcontrol = (function () {
	"use strict";

	const instance = {
		init: function (args) {
			const el = document.getElementById(args.elid);

			instance.format.jsmask = args.format;
			if (instance.format.jsmask.includes('/'))
				instance.format.delimiter = '/';
			else if (instance.format.jsmask.includes('.'))
				instance.format.delimiter = '.';

			const mask = el.getAttribute('data-format');
			instance.format.dPos = mask.indexOf('dd');
			instance.format.mPos = mask.indexOf('MM');
			instance.format.yPos = mask.indexOf('yyyy');
			instance.format.mask = mask;

			el.addEventListener('keydown', onkeydown);
			el.addEventListener('keypress', onkeypress);
			el.addEventListener('keyup', onkeyup);
			el.addEventListener('drop', ondrop);
			el.addEventListener('paste', onpaste);
			el.addEventListener('focusin', function () {
				currentVal = el.value;
			});
			el.addEventListener('focusout', function () {
				if (currentVal !== el.value)
					fireChange(el);
			});
			if (el.hasAttribute('data-orig')) {
				el.addEventListener('change', function () {
					const val = Date.parseDate(el.value, args.format);
					const orig = Date.parseDate(el.getAttribute('data-orig'), '%Y-%m-%d');
					if (val && !val.equalsTo(orig))
						el.style.backgroundColor = 'rgba(51, 153, 51, 0.1)';
					else
						el.style.backgroundColor = '';
				});
			}
		},
		format: {
			mask: undefined,
			jsmask: undefined,
			delimiter: undefined,
			mPos: undefined,
			dPos: undefined,
			yPos: undefined
		}
	};

	let currentVal = null;

	function fireInput(el) {
		el.dispatchEvent(new Event('input', { bubbles: true }));
	}

	function fireChange(el) {
		el.dispatchEvent(new Event('change', { bubbles: true }));
	}

	function onkeyup(event) {
		fireInput(event.currentTarget);
	}

	function ondrop(event) {
		pasteOrDrop(event, event.dataTransfer.getData('text'));
	}

	function onpaste(event) {
		const clipboard = event.clipboardData || window.clipboardData;
		pasteOrDrop(event, clipboard.getData('text'));
	}

	// Common handling for paste/drop: parse the incoming text, and if it is a
	// valid date, write it back normalized to the field mask. Invalid input is
	// ignored (default insertion is always prevented to keep the mask intact).
	function pasteOrDrop(event, str) {
		event.preventDefault();
		const target = event.currentTarget;
		const d = Date.parseDate(str, instance.format.jsmask);
		if (!d) return;

		target.value = d.print(instance.format.jsmask);
		target.setSelectionRange(target.value.length, target.value.length);
		fireInput(target);
		fireChange(target);
	}

	function onkeydown(event) {
		const target = event.currentTarget;
		const pos = getCaretPos(target);
		const len = target.value.length;

		if (event.key === 'Delete') {
			target.value = target.value.substring(0, pos);
			fireInput(target);
			event.preventDefault();
			return;
		}
		if (event.key === 'Backspace' && pos !== len)
			event.preventDefault();
	}

	function onkeypress(event) {
		const char = event.key;
		const target = event.currentTarget;

		// The handler fully manages the field value, so the browser's default
		// character insertion is always suppressed.
		event.preventDefault();

		if (!/^[0-9]$/.test(char))
			return;

		fireInput(target);

		let pos = getCaretPos(target);
		const val = target.value;
		let rval = val;

		if (pos > 9)
			return;

		let done = false;
		if (pos === 2 || pos === 5) {
			if (pos === rval.length)
				rval = rval + instance.format.delimiter;
			pos++;
		}

		if (pos === instance.format.mPos) {
			if ('01'.indexOf(char) === -1) {
				rval = rval.slice(0, pos) + '0' + char + rval.slice(pos + 2);
				pos++;
			}
			else if (pos < rval.length) {
				if (char !== '0' && '012'.indexOf(rval[pos + 1]) === -1) {
					rval = rval.slice(0, pos) + char + '0' + rval.slice(pos + 2);
					done = true;
				}
				else if (char === '0' && rval[pos + 1] === '0') {
					rval = rval.slice(0, pos) + char + '1' + rval.slice(pos + 2);
					done = true;
				}
			}
		}
		else if (pos === instance.format.dPos) {
			if ('0123'.indexOf(char) === -1) {
				rval = rval.slice(0, pos) + '0' + char + rval.slice(pos + 2);
				pos++;
			}
			else if (pos < rval.length) {
				if (char === '3' && '01'.indexOf(rval[pos + 1]) === -1) {
					rval = rval.slice(0, pos) + char + '0' + rval.slice(pos + 2);
					done = true;
				}
				else if (char === '0' && rval[pos + 1] === '0') {
					rval = rval.slice(0, pos) + char + '1' + rval.slice(pos + 2);
					done = true;
				}
			}
		}

		if (!done) {
			if (pos < rval.length)
				rval = rval.slice(0, pos) + char + rval.slice(pos + 1);
			else if (pos === rval.length)
				rval = rval.slice(0, pos) + char;
			else
				return;
		}

		const month = rval.slice(instance.format.mPos, instance.format.mPos + 2);
		const day = rval.slice(instance.format.dPos, instance.format.dPos + 2);
		const year = rval.slice(instance.format.yPos, instance.format.yPos + 4);

		if (month.length > 0 && '01'.indexOf(month[0]) === -1)
			return;
		if (month.length > 1 && month[0] === '1' && '012'.indexOf(month[1]) === -1)
			return;
		if (month === '00')
			return;

		if (day.length > 0 && '0123'.indexOf(day[0]) === -1)
			return;
		if (day.length > 1 && day[0] === '3' && '01'.indexOf(day[1]) === -1)
			return;
		if (day.length > 0 && day[0] === '3' && month === '02')
			return;
		const m31 = ["01", "03", "05", "07", "08", "10", "12"];
		if (day === '31' && month.length > 1 && !m31.includes(month))
			return;
		if (day === '00')
			return;

		if (year.length > 0 && '12'.indexOf(year[0]) === -1)
			return;
		if (year.length > 1 && year[0] === '1' && year[1] !== '9')
			return;
		if (year.length > 1 && year[0] === '2' && '01'.indexOf(year[1]) === -1)
			return;

		if (day === '29' && month === '02' && year.length === 4) {
			const iyear = parseInt(year, 10);
			const isLeap = ((iyear % 4 === 0) && (iyear % 100 !== 0)) || (iyear % 400 === 0);
			if (!isLeap)
				return;
		}

		target.value = rval;

		if (pos < val.length) {
			target.setSelectionRange(pos + 1, pos + 1);
			fireChange(target);
		}
	}

	function getCaretPos(field) {
		return field.selectionStart || 0;
	}

	return instance;
})();
